// eslint-disable-next-line no-unused-vars
const midtrans = {
  initScript() {
    return new Promise((resolve) => {
      let js = 'https://app.sandbox.midtrans.com/snap/snap.js';
      if (process.env.VUE_APP_MIDTRANS_MODE == 'production') {
        js = 'https://app.midtrans.com/snap/snap.js';
      }
      if (document.querySelector('script[src="' + js + '"]')) {
        resolve();
        return;
      }
      let el = document.createElement('script');
      el.setAttribute('src', js);
      el.setAttribute(
        'data-client-key',
        process.env.VUE_APP_MIDTRANS_CLIENT_KEY,
      );
      document.head.appendChild(el);
      resolve();
    });
  },

  globalWindow() {
    return new Promise((resolve) => {
      if (document.getElementById('midtrans-script')) {
        resolve();
        return;
      }
      let globs = document.createElement('script');
      globs.setAttribute('id', 'midtrans-script');
      globs.type = 'text/javascript';
      globs.innerHTML = 'window.$MIDTRANS = snap;';
      document.getElementsByTagName('head')[0].appendChild(globs);
      resolve();
    });
  },
};

export default midtrans;
